import produce from 'immer';
import { AnyAction, Reducer } from 'redux';

import { ComposedActions } from '../../helpers/actions';
import { ExecutorActions } from '../../helpers/constants';

export const hermesysInitialState = {
  tab_buttons: {
    Tab_plans_view: { active: false },
    Tab_sup_view: { active: false },
    Tab_tac_plan: { active: false },
    Tab_profile_plan: { active: false },
    Tab_conf_plan: { active: false },
    Tab_Grp_call: { active: false },
    Tab_Remote_control: { active: false },
    Tab_rediness: { active: false },
  },
};

const updateGeneralButtonStatus = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { id, isActive, activePlanName } = payload;
    if (draftState.tab_buttons[id]) {
      draftState.tab_buttons[id].active = isActive;
      if (activePlanName) {
        draftState[`${id}_active`] = activePlanName;
      }
    }
  });

const hermesysReducer: Reducer = (
  state = hermesysInitialState,
  action: AnyAction
) => {
  const { type, payload } = action;
  switch (type) {
    case ComposedActions.PressGeneralButtonSwitch.uiAction:
      return updateGeneralButtonStatus(state, payload);
    case ComposedActions.SystemUpdateGeneralButtonProperties.id:
      return updateGeneralButtonStatus(state, payload.actionPayload);
    default:
      return state;
  }
};

export default hermesysReducer;
